import { LogOut } from "lucide-react";

import { Button } from "@/components/ui/button";
import { WhatsNewLauncher } from "@/features/whats_new/components/WhatsNewLauncher";
import { useAuthState } from "@/lib/auth";

export function TopBar() {
  const { user } = useAuthState();
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-card px-5">
      <div className="text-sm text-muted-foreground">
        {user ? `Signed in as ${user.email}` : ""}
      </div>
      <div className="flex items-center gap-3">
        {user && (
          <span className="hidden text-sm font-medium text-foreground/90 sm:inline">
            {user.name || user.email}
          </span>
        )}
        <WhatsNewLauncher />
        <Button asChild variant="ghost" size="sm">
          <a href="/api/auth/logout">
            <LogOut className="h-3.5 w-3.5" />
            Log out
          </a>
        </Button>
      </div>
    </header>
  );
}
